import './utility-wrapper.scss';

export interface CenteredWrapperProps {
    children: React.ReactNode;
}

/** Centers children vertically and horizontally with consistent padding. */
export const UtilityWrapper: React.FC<CenteredWrapperProps> = ({children}) => {
    return (
        <div className={"checkboxes-tree-dropdown-utility-wrapper"}>
            {children}
        </div>
    );
};